import {Button, Center, Typography, VStack} from '@hmlet/ui'

import {Link} from '@tanstack/react-router'
import {useTranslation} from 'react-i18next'

export default function NotFound() {
  const {t} = useTranslation()
  return (
    <Center className="min-h-screen">
      <VStack gap={4} align="center">
        <Typography variant="h4">{t('pageNotFound')}</Typography>
        <Button asChild>
          <Link to="/">{t("navOverview")}</Link>
        </Button>
      </VStack>
    </Center>
  )
}
